import { useContext, useRef } from 'react';
import { Button } from '@monash/portal-react';
import { format } from 'date-fns';

import c from '../version-history-menu.module.scss';
import { AccessibilityContext } from '@monash/portal-frontend-common';

export const ViewRestoreButton = ({
  view,
  restore,
  isSelected,
  timestamp,
  index,
}) => {
  const buttonRef = useRef(null);
  const dateDisplay = format(timestamp, 'h:mmaaa, d MMM y');
  const actionText = isSelected ? 'Restore' : 'View';
  const { resetAppLiveMsgs, setAppLivePoliteMsg } =
    useContext(AccessibilityContext);

  const onClick = () => {
    if (isSelected) {
      restore(index);
    } else {
      view(index);
    }

    resetAppLiveMsgs();

    setTimeout(() => {
      if (isSelected) {
        setAppLivePoliteMsg(`Version at ${dateDisplay} restored`);
      } else {
        setAppLivePoliteMsg(`Viewing version at ${dateDisplay}`);
      }
    }, 200);
  };

  return (
    <Button
      className={c.button}
      variant="text"
      size="small"
      onClick={onClick}
      aria-label={`${actionText} version at ${dateDisplay}`}
      ref={buttonRef}
      aria-current={isSelected}
      data-tracking-event={
        'custom-widget-note-versioning-' + `${actionText?.toLowerCase()}}`
      }
    >
      {actionText}
    </Button>
  );
};
